import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { StatutoryDeduction, StatutoryDeductionCreate, StatutoryDeductionFilter } from '../data/statutoryDeduction';

export function createStatutoryDeductionService(client: AxiosInstance) {
  return createCrudService<StatutoryDeduction, StatutoryDeductionCreate, StatutoryDeductionFilter>(
    client,
    '/hrm/StatutoryDeduction',
    'id',
  );
}

export type StatutoryDeductionService = CrudService<StatutoryDeduction, StatutoryDeductionCreate, StatutoryDeductionFilter>;
